// O que o chat tem (operadores, encomendas, campanhas, cartoes, carrinho, convites, CSAT, voz, sessoes). A regra decide-se
// no backend (D1): aqui so se leem os booleanos. O ALL_SHOWN serve o intervalo entre os deploys dos dois
// repositorios (D8), em que um /summary sem `capabilities` desenha a pagina de antes, e e a base dos
// testes: o `summaryFixture` tem tudo ligado, e cada teste desliga o que precisa. As capacidades do item 11
// (customer_profile, size_searches) ficam fora: um /summary sem elas esconde a seccao do perfil (D9).
export const ALL_SHOWN = {
  operators: true,
  orders: true,
  orders_variant: "lookup",
  campaigns: true,
  cards: true,
  cart: true,
  invites: true,
  voice: true,
  csat: true,
  sessions: true,
};

export const capabilitiesOf = (summary) => summary.capabilities || ALL_SHOWN;

// Tira os itens que precisam de uma capacidade desligada, pela mesma ordem. Sem `needs` ficam sempre.
export const shownOnly = (items, capabilities) => items.filter((item) => !item.needs || capabilities[item.needs]);

// O CSAT mostra os dois grupos (com operador e so com o assistente) num chat com operadores, e tambem
// num que os desligou entretanto mas teve pedidos com operador no periodo: uma conversa da fase humana
// nascida antes do periodo e fechada dentro dele traz avaliacoes com operador (D12).
export const csatWithOperators = (summary) => capabilitiesOf(summary).operators || summary.csat.with_operator.requested > 0;

// A lista do CSAT por operador, desenhada no bloco e pedida pela pagina com a mesma regra, para nao
// discordarem: so a quem pode abrir conversas, com a avaliacao ligada, com operadores e com pedidos no
// periodo (sem pedidos o bloco so mostra uma frase).
export const csatListShown = (summary, canOpenConversations) =>
  Boolean(canOpenConversations && summary.csat && capabilitiesOf(summary).csat && csatWithOperators(summary) && summary.csat.all.requested > 0);

// A seccao das sessoes e o pedido dos clientes distintos usam a mesma regra: o bloco `sessions` do resumo
// e a capacidade. Um backend de antes da leitura nao manda o bloco, e com o ALL_SHOWN a capacidade vem a
// true: so o bloco o distingue (D16).
export const sessionsShown = (summary) => Boolean(summary.sessions && capabilitiesOf(summary).sessions);
